import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { initSentry, SentryErrorBoundary } from "./sentry";

initSentry();

// Fallback shown when a React render error escapes all our boundaries.
// Looks intentional rather than a white screen of death.
function CrashFallback({ resetError }) {
  return (
    <div style={{
      minHeight: "100vh", display: "flex", alignItems: "center",
      justifyContent: "center", padding: 24, fontFamily: "sans-serif",
      background: "#fafafa",
    }}>
      <div style={{ maxWidth: 420, textAlign: "center" }}>
        <div style={{ fontSize: 48, marginBottom: 16 }}>😬</div>
        <div style={{ fontSize: 18, fontWeight: 700, marginBottom: 8 }}>
          Something went wrong
        </div>
        <div style={{ fontSize: 13, color: "#555", marginBottom: 16, lineHeight: 1.5 }}>
          The error has been reported. Try reloading — if it keeps happening,
          send your company owner a screenshot.
        </div>
        <button
          onClick={() => { resetError(); window.location.reload(); }}
          style={{
            background: "#185FA5", color: "#fff", border: "none",
            borderRadius: 8, padding: "10px 20px", fontSize: 14, fontWeight: 600,
            cursor: "pointer",
          }}
        >Reload app</button>
      </div>
    </div>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <SentryErrorBoundary fallback={CrashFallback} showDialog={false}>
      <App />
    </SentryErrorBoundary>
  </React.StrictMode>
);
